var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.alternate ? "Alternatively, v" : "V")+"isit the "),_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("Downloads")]),_vm._v(" section of the "+_vm._s(_vm.site)+" to download the latest binaries. ")])}
var staticRenderFns = []

export { render, staticRenderFns }